import React from "react";
import AdminDashLayout from "../../../../Components/Admin/AdminDashLayout";
import CardsSection from "./CardsSection";
import useNavHeading from "../../../../Hooks/CommonHooks/useNavHeading ";
import { FiPlus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import RecentReceipts from "./Components/RecentReceipts.table";
import ProtectedSection from "../../../../Routes/ProtectedRoutes/ProtectedSection";
import { PERMISSIONS } from "../../../../config/permission";
import ProtectedAction from "../../../../Routes/ProtectedRoutes/ProtectedAction";
import Layout from "../../../../Components/Common/Layout";
import { useTranslation } from "react-i18next";

const ReceiptsMain = () => {
  useNavHeading("Finance", "Receipts");
  const navigate = useNavigate();
  const { t } = useTranslation("prtFinance");
  return (
    <Layout title={"Receipts | Office Flow"}>
      <AdminDashLayout>
        <ProtectedSection requiredPermission={PERMISSIONS.SHOW_RECIEPT_SECTION}>
          <div className="p-4 gap-y-6 bg-gray-50 min-h-screen">
            {/* Header Section */}
            <ProtectedAction requiredPermission={PERMISSIONS.ADD_NEW_RECIEPT}>
              <div className="flex justify-between items-center bg-white rounded-xl shadow-sm p-4 mb-4">
                <div>
                  <h1 className="page-heading w-44">{t("Receipts")}</h1>
                  <p className="subheading">
                    {t("Overview of all recorded receipt transactions.")}
                  </p>
                </div>

                {/* Add New Receipt Button */}
                <button
                  onClick={() => navigate("/finance/receipts/add-new-receipt")}
                  className="inline-flex items-center border border-gray-300 rounded-full ps-4 bg-white hover:shadow-lg transition duration-200 gap-2"
                >
                  <span className="text-gray-800 font-medium">
                    {t("Add New Receipt")}
                  </span>
                  <div className="w-12 h-12 rounded-full  btn-gradient flex items-center justify-center text-white">
                    <FiPlus size={16} />
                  </div>
                </button>
              </div>
            </ProtectedAction>

            <CardsSection />
            <RecentReceipts />
          </div>
        </ProtectedSection>
      </AdminDashLayout>
    </Layout>
  );
};

export default ReceiptsMain;
